import {
  getAccessibilityEventBySlug,
  getEventBySlug,
  getPrivateEventBySlug
} from "./chunk-QUIXPXRE.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/events/eventDetail.ts
import { useQuery } from "@tanstack/react-query";
var useGetTicketingEvent = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: [
      "getTicketingEvent",
      __spreadProps(__spreadValues({}, props), { private: props.private === true ? true : void 0 })
    ],
    queryFn: () => {
      if (props.private) {
        return getPrivateEventBySlug(props);
      }
      return getEventBySlug(props);
    },
    staleTime: 6e4,
    retryOnMount: false
  }, options));
};
var useGetAccessibilityTicketingEvent = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getAccessibilityEventBySlug", props],
    queryFn: () => {
      return getAccessibilityEventBySlug(props);
    }
  }, options));
};

export {
  useGetTicketingEvent,
  useGetAccessibilityTicketingEvent
};
//# sourceMappingURL=chunk-2FYM5JU6.mjs.map